import "./style.less";

export default function HouseCard() {
    return {
        restrict: "E",
        scope: {
            house: "=", //object
            houseType: "@", // string
        },
        template: require("./template.html"),

        controller: function (
            $scope,
            houseService,
            siteService,
            searchBarFactory,
            Scroll
        ) {
            $scope.debug = false;

            $scope.selectHouse = function (house) {
                if ($scope.houseType == "activity") {
                    house.ThumbURL = house.Image;
                    house.CategoryID = house.ID;

                    // houseService.searchFilter.houseCategory = house;
                    searchBarFactory.selectItem(
                        house,
                        searchBarFactory.oSearchCategory,
                        false
                    );
                }

                if ($scope.houseType == "location") {
                    // houseService.searchFilter.houseType = house;
                    searchBarFactory.selectItem(
                        house,
                        searchBarFactory.oSearchType,
                        false
                    );

                    //console.log(selectedHouseType);
                }

                // houseService.searchFilter.syncSearchBar(house);

                //scroll top search results
                Scroll.to("main-content-focus", siteService.headerHeight + 15);

                searchBarFactory.searchBroadcast();
            };
        },
    };
}
